import { render } from "./BreadcrumbSection.vue?vue&type=template&id=54071e14&scoped=true"
import script from "./BreadcrumbSection.vue?vue&type=script&lang=js"
export * from "./BreadcrumbSection.vue?vue&type=script&lang=js"

import "./BreadcrumbSection.vue?vue&type=style&index=0&id=54071e14&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54071e14"]])

export default __exports__